import React, { useState, useRef, useEffect } from 'react';

import './ProductList.scss';
import icons from '../../shared/assets/icons';
import { getString } from '../../helpers/styles';

const { ShoppingCart, Star, LeftArrow, RightArrow } = icons;

let touchstartX = 0;
let touchendX = 0;

export default function ProductList(props) {
  if (!props.useQuery) props.useQuery = () => ({});

  const horizontalView = props.view === 'horizontal' || !!props.code;

  const [query, variables] = props.code
    ? [props.productCategoryQuery, { code: props.code }]
    : [props.getListQuery, { name: props.listName }];

  const { data = {}, loading } = props.useQuery(query, { variables });

  const loadedList =
    (data.getList && data.getList.items) ||
    (data.productCategory && data.productCategory.products);

  const categoryName = data.productCategory && data.productCategory.name;

  const list = loadedList || props.list || [];

  const [currentPage, togglePage] = useState(1);

  const [lastPage, setLastPage] = useState(1);

  const productList = useRef(null);

  useEffect(() => {
    if (!loading) {
      if (document.body.offsetWidth <= 850) setLastPage(list.length);
      else setLastPage(list.length > 2 ? list.length - 1 : 1);

      if (horizontalView)
        productList.current.ontouchmove = (e) => {
          // Check if it's not strictly vertical swipe
          // and then block vertical page scrolling
          if (Math.abs(touchstartX - e.changedTouches[0].screenX) > 5)
            e.preventDefault();
        };
    }
  }, [loading, list.length, horizontalView]);

  return list ? (
    <section
      id="_productList"
      className={getString('_productList_horizontal_view', horizontalView)}
    >
      {horizontalView && categoryName && (
        <h2>Speciaal voor jou geselecteerde {categoryName}</h2>
      )}

      <div id="_productList_content">
        {currentPage !== 1 && (
          <div
            className="_productList_arrow_left _productList_arrow"
            onClick={() => move('backward')}
          >
            <LeftArrow />
          </div>
        )}

        <ul
          ref={productList}
          onTouchStart={(e) => (touchstartX = e.changedTouches[0].screenX)}
          onTouchEnd={(e) => swipe(e)}
        >
          {list.map((item, idx) => {
            const product = item.product || item;

            return (
              <li key={idx}>
                <div className="_productList_item">
                  <div className="_productList_image">
                    <img
                      alt="product-image"
                      src={item.imageUrl || product.imageUrl}
                    />

                    {product.category && (
                      <p className="_productList_category">
                        {product.category}
                      </p>
                    )}
                  </div>

                  <div className="_productList_info">
                    <div>
                      <p className="_productList_title">
                        {item.title || product.name}
                      </p>

                      <p className="_productList_supplier">
                        Aangeboden door <br />
                        <div>
                          <span>{product.supplier}</span> -{' '}
                          {'\u20AC'.repeat(product.priceLevel)}
                        </div>
                      </p>
                    </div>

                    <div className="_productList_prices">
                      {product.oldPrice ? (
                        <React.Fragment>
                          <p className="_productList_discount_price">
                            <span>€ {product.price}</span>
                          </p>
                          <p className="_productList_old_price">
                            <span>€ {product.oldPrice}</span>
                          </p>
                        </React.Fragment>
                      ) : (
                        <p className="_productList_price">€ {product.price}</p>
                      )}
                    </div>

                    <div className="_productList_rating">
                      {Array.from({ length: 5 }).map((_, idx) => (
                        <span
                          className={getString(
                            '_productList_star_filled',
                            idx < +product.rating
                          )}
                          key={idx}
                        >
                          <Star />
                        </span>
                      ))}
                    </div>

                    <div className="_productList_button">
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href={product.shopUrl}
                      >
                        <ShoppingCart />
                        Bekijk product
                      </a>
                    </div>
                  </div>

                  <div className="_productList_benefits">
                    <ul>
                      {product.prosAndCons
                        .split('+')
                        .slice(1)
                        .map((item, idx) => (
                          <li key={idx}>
                            <span>&#65291;</span>
                            <div>{item}</div>
                          </li>
                        ))}
                    </ul>

                    <ul>
                      {(product.disadvantages || []).map((item, idx) => (
                        <li key={idx}>
                          <span>&#8722;</span> {item}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </li>
            );
          })}
        </ul>

        {currentPage !== lastPage && (
          <div
            className="_productList_arrow_right _productList_arrow"
            onClick={() => move('forward')}
          >
            <RightArrow />
          </div>
        )}
      </div>
    </section>
  ) : null;

  function move(direction) {
    const isForward = direction === 'forward';

    const multiplier = document.body.offsetWidth <= 850 ? 0.85 : 0.5;

    const translateX = `${
      (isForward ? `-${currentPage}` : `-${currentPage - 2}`) * multiplier * 100
    }%`;

    productList.current.style.cssText = `
      transition-duration: .3s;
      transition-property: transform;
      transform: translateX(${translateX});
    `;

    togglePage((previousPage) =>
      isForward ? previousPage + 1 : previousPage - 1
    );
  }

  function swipe(e) {
    touchendX = e.changedTouches[0].screenX;

    const delta = touchendX - touchstartX;

    if (delta > 20) move('backward');
    else if (delta < -20 && currentPage !== lastPage) move('forward');
  }
}
